








import Socket from '@/mixins/socket';
import { Vue, Component } from 'vue-property-decorator'

export default class Navbar extends Socket {
    get isPresentView(): boolean {
        if(this.$route.name === 'event-present') return true;
        return false;
    }
    get fullName(): string {
        if(!this.user.firstName) return "";
        return this.user.firstName + " " + this.user.lastName;
    }
    get votingStatus():string {
        if(this.user && this.user.voteCount) return 'Äänioikeus';
        return 'Ei äänioikeutta';
    }
}
